module.exports = __webpack_public_path__ + "img/75.6.CODm.69089a1e.png";